'use client'

import { isbot } from 'isbot'

import * as gtag from '@lib/gtag'

import getCookieConsentValue from './get-cookie-consent-value'

export default async function sendEventToAnalytics(
  event: string,
  params: Record<string, string | boolean | string[]>,
): Promise<void> {
  const userAgent = navigator.userAgent
  // A crawler hit is not a session: it inflates every funnel, conversion rate and pageview count
  // it lands in. Dropped here rather than per caller so no analytics backend ever sees it.
  if (isbot(userAgent)) {
    return
  }

  const { mixpanel } = await import('@lib/mixpanel')
  // iPadOS Safari defaults to desktop-class browsing and sends a Macintosh user agent
  // indistinguishable from macOS, so touch support is the only signal left — no Mac has a
  // touchscreen. Costs us iPhones with "Request Desktop Website" on, which is opt-in and rare.
  const isTablet =
    /iPad|Tablet|Android(?!.*Mobile)/i.test(userAgent) || (/Macintosh/.test(userAgent) && navigator.maxTouchPoints > 1)

  gtag.event(event, params)
  mixpanel.track(event, {
    ...params,
    areCookiesAccepted: getCookieConsentValue(),
    userAgent,
    deviceType: isTablet ? 'tablet' : /Mobile|iPhone|Android/i.test(userAgent) ? 'smartphone' : 'desktop',
  })
  if (window.rdt) {
    window.rdt('track', 'Custom', {
      customEventName: event,
      ...params,
    })
  }
}
